import { toWSDateString } from "@wingspanhq/fe-component-library";

export const getTmpEngagementName = (engagement: { createdAt: Date }) => {
  return `Engagement ${toWSDateString(engagement.createdAt, "monthDayYear")}`;
};
